@if (isLoading()) {
  <div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
      <p style="color: white">{{ 'loading' | translate }}...</p>
    </ngx-spinner>
  </div>
}
